import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../Redux/store";
import { InteractionScreen, setScreen } from "../../../Redux/screenInteractionsSlice";

export interface ILink {
    text: string;
    to: string
}

interface IProps {
    links: Array<{ text: string, to: string }>;
}

export const LinkDropDown: React.FC<IProps> = ({ links }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [selectedOption, setSelectedOption] = useState<ILink>();

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        setSelectedOption({ text: links.find(l => l.to === window.location.pathname)?.text ?? '', to: window.location.pathname })
    }, [])


    const selectOption = (option: ILink) => {
        setSelectedOption(option);
        setOpen(false);
        navigate(option.to);

        switch (option.text) {
            case 'Build':
                return dispatch(setScreen(InteractionScreen.SANDBOX));
            default:
                dispatch(setScreen(InteractionScreen.HOME));
        };
    }

    return (
        <div
            className="h-min-[48px] h-fit w-[160px] z-30 bg-white heavy-border-shadow box-content cursor-pointer"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            {open ? (
                <>
                    {[selectedOption, ...links.filter((l, i) => l.text !== selectedOption?.text)].map((l, i) => {
                        return (
                            <p
                                className={`font-pixel-text text-sm text-center h-10 flex items-center justify-center ${i === 0 ? '' : 'link'}`}
                                onClick={i === 0 ? undefined : () => selectOption({ text: l?.text ?? '', to: l?.to ?? '' })}
                                key={l?.text}
                            >
                                {l?.text}
                            </p>
                        )
                    })
                    }
                </>
            )
                : <p className="font-pixel-text text-sm text-center h-10 flex items-center justify-center">{selectedOption?.text}</p>
            }
        </div>
    )
}